import { render } from "./QuestionOption.vue?vue&type=template&id=e3077482"
import script from "./QuestionOption.vue?vue&type=script&lang=js"
export * from "./QuestionOption.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__